import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { finalize } from 'rxjs';
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { DocumentViewerService } from 'src/app/services/document-viewer.service';
import { FormValidation } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NgIconComponent } from '@ng-icons/core';


interface FormField {
  id: string;
  label: string;
  type: 'text' | 'date' | 'select' | 'textarea' | 'radio';
  required: boolean;
  placeholder?: string;
  options?: string[];
}

interface DocumentConfig {
  title: string;
  uploadAvailable: boolean;
  uploadText: string;
  fields: FormField[];
}

@Component({
  selector: 'app-candidate-documents',
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    TruncatePipe,
    TitleCasePipe,
    DatePipe,
DndDirective
  ,
    NgIconComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './candidate-documents.component.html',
  styleUrls: ['./candidate-documents.component.scss']
})
export class CandidateDocumentsComponent extends FormValidation implements OnInit, OnDestroy {

  @Input() pageName: any;
  @Input() isOpen: boolean = false;
  @Input() listOfDocuments: any;
  @Input() candidateId: any;
  @Input() jobId: any;
  @Input() count:any;
  @Input() allDocumentsVerified: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() dataChanged = new EventEmitter<void>();

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private util: UtilService,
    private api: ApiService,
    private cdr: ChangeDetectorRef,
    private documentViewerService: DocumentViewerService
  ) {
    super();
  }

  ngOnInit(): void {
    console.log('typeOfDocuments :', this.listOfDocuments);
    this.getCountries();
  }

  ngOnDestroy(): void {

  }

  countryList= [];
  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.api.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        this.countryList = res;
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  eadList:any = [];
  getEADType(countryCode:any){
    let domain = 'WORK_AUTHORIZATION_';
    this.eadList = [];
    const supportedCountries = ['US','IN','CA','AU'];

    console.log('Selected country code:', countryCode); // Debug log

    if(supportedCountries.includes(countryCode)){
      domain = domain + countryCode;
      this.util.startLoader();
      this.api.query('listvalue/find?domain='+domain).subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader();
          this.eadList = []; // Clear before populating
          res.data.listValues[0].listItems.forEach(ele => {
            this.eadList.push(ele.item);
          });
          // Remove duplicates
          this.eadList = [...new Set(this.eadList)];
          console.log('EAD list populated:', this.eadList); // Debug log

          // Refresh the document configuration to update dropdown options
          this.refreshDocumentConfig();
        } else {
          this.util.stopLoader();
          console.error('Error response from API:', res);
          this.eadList = [];
          this.refreshDocumentConfig();
        }
      }, error => {
        this.util.stopLoader();
        console.error('Error fetching EAD list:', error);
        this.eadList = [];
        this.refreshDocumentConfig();
      });
    } else {
      console.log('Country not supported for EAD:', countryCode); // Debug log
      // If country is not supported, clear the EAD list and refresh config
      this.eadList = [];
      this.refreshDocumentConfig();
    }
  }

  expandedIndex: number | null = null;

  toggleAccordion(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }

  saveDocuments() {
    this.save.emit(this.listOfDocuments);
  }

  closeDocuments() {
    this.close.emit();
  }

  DocumentName: any;
  closeResult: any;
  selectedFiles: File[] = [];
  maxFileSize = 10 * 1024 * 1024; // 10MB
  allowedFileTypes = ['.pdf', '.docx', '.doc', '.xls', '.xlsx', '.png', '.jpg', '.jpeg'];

  modalType: any;

  openModal(m: any, d: any, modalType: any, obj?: any) {
    this.DocumentName = d;
    this.selectedFiles = [];
    this.currentDocumentConfig = this.getDocumentConfig(d);
    this.formData = {};
    this.formErrors = {};
    this.documentStatus = 'pending';
    this.showStatusButtons = false;

    this.modalType = modalType;

    // If editing Employment Authorization Document, pre-load EAD list if country exists
    if (modalType == 'edit' && d === 'Employment Authorization Document' && obj?.countryOfCitizenship) {
      console.log('Edit mode: Pre-loading EAD list for country:', obj.countryOfCitizenship);
      this.getEADType(obj.countryOfCitizenship);
    }

    if (modalType == 'edit') {
      this.initializeForm(obj);
    } else {
      // Initialize FormGroup dynamically based on document configuration
      this.initializeForm();
    }

    this.modalService.open(m, {
      size: 'md', // Make it larger for forms
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closeModal() {
    this.DocumentName = null;
    this.showRejectionReason = false;
    this.fileDragdrop = null;
    this.modalService.dismissAll();
  }

  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  fileSize = AppSettings.FILE_SIZE;
  resumeupload: any;

  // Dynamic form properties
  currentDocumentConfig: DocumentConfig | null = null;
  documentForm: FormGroup = this.formBuilder.group({});
  formData: { [key: string]: any } = {};
  formErrors: { [key: string]: string } = {};
  showStatusButtons: boolean = false;
  documentStatus: 'pending' | 'verified' | 'rejected' = 'pending';
  showRejectionReason: boolean = false;

  // Document configurations
  documentConfigs: { [key: string]: DocumentConfig } = {
    'Resume': {
      title: 'Resume',
      uploadAvailable: true,
      uploadText: 'Upload your Resume',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' }
      ]
    },
    'Employment Authorization Document': {
      title: 'Employment Authorization Document',
      uploadAvailable: true,
      uploadText: 'Upload your Employment Authorization Document',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'validFromDate', label: 'Valid From', type: 'date', required: true },
        { id: 'expiryDate', label: 'Valid Until', type: 'date', required: true },
        { id: 'countryOfCitizenship', label: 'Country of Citizenship', type: 'select', required: true, placeholder: 'Enter country name', options :this.countryList },
        { id: 'employDocumentType', label: 'Document Type', type: 'select', required: true, options: this.eadList }
      ]
    },
    'Drivers License': {
      title: 'Drivers License',
      uploadAvailable: true,
      uploadText: 'Upload your Drivers License',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'validFromDate', label: 'Issue Date', type: 'date', required: true },
        { id: 'expiryDate', label: 'Expiration Date', type: 'date', required: true },
        { id: 'stateOfIssuance', label: 'State of Issuance', type: 'text', required: true,  placeholder: 'State of Issuance' }
      ]
    },
    'Visa': {
      title: 'Visa',
      uploadAvailable: true,
      uploadText: 'Upload your Visa',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'validFromDate', label: 'Issue Date', type: 'date', required: true },
        { id: 'expiryDate', label: 'Expiration Date', type: 'date', required: true },
        { id: 'countryOfIssuance', label: 'Country of Issuance', type: 'select', required: true, placeholder: 'Enter country name',options:this.countryList }
      ]
    },
    'Passport': {
      title: 'Passport',
      uploadAvailable: true,
      uploadText: 'Upload your Passport',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'validFromDate', label: 'Issue Date', type: 'date', required: true },
        { id: 'expiryDate', label: 'Expiration Date', type: 'date', required: true },
        { id: 'countryOfIssuance', label: 'Country of Issuance', type: 'select', required: true, placeholder: 'Enter country name',options: this.countryList }
      ]
    },
    'I-94': {
      title: 'I-94 Travel Record',
      uploadAvailable: true,
      uploadText: 'Upload your I-94 Travel Record',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'validFromDate', label: 'Arrival Date', type: 'date', required: true },
        { id: 'expiryDate', label: 'Expiration Date', type: 'date', required: true },
        { id: 'countryOfIssuance', label: 'Country of Issuance', type: 'select', required: true, placeholder: 'Enter country name',options: this.countryList }
      ]
    },
    'Background Check Certification': {
      title: 'Background Verification Certification',
      uploadAvailable: true,
      uploadText: 'Upload your Background Verification Certificate',
      fields: [
        { id: 'originalFileName', label: 'File Name', type: 'text', required: true, placeholder: 'Uploaded file name' },
        { id: 'backgroudVerifyType', label: 'Background Verification Type', type: 'select',placeholder: 'Select verification type', required: true, options: ['7 year Background Check', '10 year Background Check', '6 Panel Drug Screen'] },
        { id: 'completedOn', label: 'Completed On', type: 'date', required: true },
        { id: 'comments', label: 'Comments', type: 'textarea', required: true, placeholder: 'Add comments' }
      ]
    },
    'Background Verification': {
      title: 'Drug Screening',
      uploadAvailable: false,
      uploadText: 'Upload your Drug Screening Results',
      fields: [
        { id: 'backgroudVerifyType', label: 'Verification Type', type: 'select', required: true,placeholder: 'Select Verification Type', options: ['7 year Background Check', '10 year Background Check'] },
        { id: 'backgroundDrugStatus', label: 'Status', type: 'select', required: true,placeholder: 'Select status', options: ['Pending', 'Inprocess', 'Completed'] },
        { id: 'completedOn', label: 'Completed On', type: 'date', required: true },
        { id: 'result', label: 'Result', type: 'radio', required: true, options: ['pass', 'fail'] },
        { id: 'comments', label: 'Comments', type: 'textarea', required: true, placeholder: 'Add comments' }
      ]
    },
    'Drug Screening': {
      title: 'Drug Screening',
      uploadAvailable: false,
      uploadText: 'Upload your Drug Screening Results',
      fields: [
        { id: 'drugScreenType', label: 'Screening Type', type: 'select', required: true,placeholder: 'Select Screening Type', options: ['6 Panel Drug Screen'] },
        { id: 'backgroundDrugStatus', label: 'Status', type: 'select', required: true,placeholder: 'Select status', options: ['Pending', 'Inprocess', 'Completed'] },
        { id: 'completedOn', label: 'Completed On', type: 'date', required: true },
        { id: 'result', label: 'Result', type: 'radio', required: true, options: ['pass', 'fail'] },
        { id: 'comments', label: 'Comments', type: 'textarea', required: true, placeholder: 'Add comments' }
      ]
    }
  };

  // Helper methods for dynamic table display
  getTableHeaders(documentName: string): string[] {
    const config = this.getDocumentConfig(documentName);
    if (!config || !config.fields) {
      return ['Document Name', 'Last Updated', 'Valid From', 'Expiry', 'Status', 'Quick Actions'];
    }

    const headers: string[] = [];

    // Add headers based on document configuration
    config.fields.forEach(field => {
      if (field.id === 'originalFileName') {
        headers.push('Document Name');
      } else if (field.id === 'validFromDate') {
        headers.push('Valid From');
      } else if (field.id === 'expiryDate') {
        headers.push('Expiry');
      } else if (field.id === 'employDocumentType') {
        headers.push('Document Type');
      } else if (field.id === 'stateOfIssuance') {
        headers.push('State');
      } else if (field.id === 'countryOfIssuance') {
        headers.push('Country Of Issuance');
      } else if(field.id === 'countryOfCitizenship'){
        headers.push('Country Of Citizenship');
      } else if (field.id === 'backgroudVerifyType') {
        headers.push('Background Type');
      } else if(field.id === 'drugScreenType'){
        headers.push('Drug Screen Type')
      } else if (field.id === 'completedOn') {
        headers.push('Completed On');
      } else if (field.id === 'result') {
        headers.push('Result');
      } else if (field.id === 'backgroundDrugStatus') {
        headers.push('Process Status');
      }
    });

    // Always add Last Updated, Status, and Actions as standard columns
    if (!headers.includes('Last Updated')) {
      headers.push('Last Updated');
    }
    headers.push('Status');
    headers.push('Quick Actions');

    return headers;
  }

  // Dynamic method to get document configuration with updated data
  getDocumentConfig(documentName: string): DocumentConfig | null {
    const baseConfig = this.documentConfigs[documentName];
    if (!baseConfig) return null;

    // Create a copy of the configuration
    const config: DocumentConfig = JSON.parse(JSON.stringify(baseConfig));

    // Update dynamic options based on document type
    if (documentName === 'Employment Authorization Document') {
      config.fields = config.fields.map(field => {
        if (field.id === 'employDocumentType') {
          // Always use the current eadList, even if empty
          return { ...field, options: [...this.eadList] };
        }
        if (field.id === 'countryOfCitizenship') {
          // Always use the current countryList
          return { ...field, options: [...this.countryList] };
        }
        return field;
      });
    } else if (['Visa', 'Passport', 'I-94'].includes(documentName)) {
      config.fields = config.fields.map(field => {
        if (field.id === 'countryOfIssuance') {
          // Always use the current countryList
          return { ...field, options: [...this.countryList] };
        }
        return field;
      });
    }

    return config;
  }

  getFieldValue(document: any, fieldId: string): string {
    if (!document || !fieldId) return '-';

    const value = document[fieldId];
    if (!value) return '-';

    // Format dates
    if (fieldId.includes('Date') || fieldId === 'completedOn') {
      return this.formatDate(value);
    }

    return value;
  }

  private formatDate(dateValue: any): string {
    if (!dateValue) return '-';

    try {
      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '-';

      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();

      // App-standard display format (MM/dd/yyyy)
      return `${month}/${day}/${year}`;
    } catch {
      return '-';
    }
  }

  getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  shouldShowColumn(documentName: string, columnType: string): boolean {
    const config = this.getDocumentConfig(documentName);
    if (!config) return true;

    // Always show these columns
    if (['Document Name', 'Last Updated', 'Status', 'Quick Actions'].includes(columnType)) {
      return true;
    }

    // Check if document config has relevant fields
    const hasField = config.fields?.some(field => {
      switch (columnType) {
        case 'Valid From':
        case 'Issue Date':
        case 'Arrival Date':
          return field.id === 'validFromDate';
        case 'Expiry':
        case 'Expiration Date':
        case 'Valid Until':
          return field.id === 'expiryDate';
        case 'Document Type':
          return field.id === 'employDocumentType';
        case 'State':
          return field.id === 'stateOfIssuance';
        case 'Country':
          return field.id === 'countryOfIssuance' || field.id === 'countryOfCitizenship';
        case 'Type':
          return field.id === 'backgroudVerifyType' || field.id === 'drugScreenType';
        case 'Completed On':
          return field.id === 'completedOn';
        case 'Result':
          return field.id === 'result';
        case 'Process Status':
          return field.id === 'backgroundDrugStatus';
        default:
          return false;
      }
    });

    return hasField || false;
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('fileBrowseHandler called with:', files);
    console.log('Number of files:', files ? files.length : 0);

    if (files && files.length > 0) {
      console.log('Processing files...');
      this.prepareFilesList(files);
    } else {
      console.log('No files to process in fileBrowseHandler');
    }
  }

  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }

    const file = files[0]; // Get the first file
    console.log('Processing file:', file);

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", 'File size exceeds maximum limit of 10 MB', "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'image/png',
      'image/jpeg',
      'image/jpg'
    ];

    console.log('File type:', file.type);

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type) || file) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;

      // Auto-patch the file name into the form data if fileName field exists
      if (this.currentDocumentConfig?.fields?.some(field => field.id === 'originalFileName')) {
        this.formData['originalFileName'] = file.name;
        // Also patch to reactive form if it exists
        if (this.documentForm.get('originalFileName')) {
          this.documentForm.patchValue({ originalFileName: file.name });
        }
        console.log('Auto-patched file name:', file.name);
      }
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  removeFiles() {
    console.log('Removing files...');
    this.fileDragdrop = null;
    this.resumeupload = null;
    this.selectedFiles = [];


      if (this.documentForm.get('originalFileName')) {
    this.documentForm.patchValue({ originalFileName: '' });
  }
    // Reset the file input element more reliably
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      const input = this.fileDropRef.nativeElement;
      input.value = '';

      // Force a complete reset by setting the input type to text and back to file
      // This ensures the browser completely resets the input
      setTimeout(() => {
        const originalType = input.type;
        input.type = 'text';
        input.type = originalType;
      }, 10);
    }

    console.log('Files removed and input reset');
  }


  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  handleFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (this.validateFile(file)) {
        // Check if file already exists
        const existingFileIndex = this.selectedFiles.findIndex(f => f.name === file.name);
        if (existingFileIndex === -1) {
          this.selectedFiles.push(file);
        } else {
          // Replace existing file
          this.selectedFiles[existingFileIndex] = file;
        }
      }
    }
  }

  validateFile(file: File): boolean {
    // Check file size
    if (file.size > this.maxFileSize) {
      alert(`File "${file.name}" is too large. Maximum size is 10MB.`);
      return false;
    }

    // Check file type
    const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
    if (!this.allowedFileTypes.includes(fileExtension)) {
      alert(`File "${file.name}" has an unsupported format. Only PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG files are allowed.`);
      return false;
    }

    return true;
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }

  getFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  getFileIcon(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'fas fa-file-pdf';
      case 'docx':
      case 'doc':
        return 'fas fa-file-word';
      case 'txt':
        return 'fas fa-file-alt';
      default:
        return 'fas fa-file';
    }
  }

  // Drag and drop handlers
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const uploadBox = event.currentTarget as HTMLElement;
    uploadBox.classList.add('dragover');
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const uploadBox = event.currentTarget as HTMLElement;
    uploadBox.classList.remove('dragover');
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const uploadBox = event.currentTarget as HTMLElement;
    uploadBox.classList.remove('dragover');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFiles(files);
    }
  }

  // Form validation methods
  validateForm(): boolean {
    this.formErrors = {};
    let isValid = true;

    if (!this.currentDocumentConfig) return true;

    this.currentDocumentConfig.fields.forEach(field => {
      const value = this.formData[field.id];

      if (field.required && (!value || value.toString().trim() === '')) {
        this.formErrors[field.id] = `${field.label} is required`;
        isValid = false;
      }
    });

    return isValid;
  }

  onFieldChange(fieldId: string, value: any) {
    this.formData[fieldId] = value;
    // Clear error when user starts typing
    if (this.formErrors[fieldId]) {
      delete this.formErrors[fieldId];
    }
  }

  setDocumentStatus(status: 'verified' | 'rejected', doc?: any) {
    const rejectionReasonControl = this.documentForm.get('rejectionReason');

    if (status === 'verified') {
      // Clear rejection reason validators
      if (rejectionReasonControl) {
        rejectionReasonControl.clearValidators();
        rejectionReasonControl.setValue('');
        rejectionReasonControl.updateValueAndValidity();
      }

      // Validate full form
      if (this.documentForm.invalid) {
        this.documentForm.markAllAsTouched();
        return;
      }

      // ✅ Call API directly
      this.verifyRejectDocument(doc, status);
    } else if (status === 'rejected') {
      // First click → just show the rejection field, don’t call API
      if (!this.showRejectionReason) {
        this.showRejectionReason = true;
        this.documentStatus = status;

        if (rejectionReasonControl) {
          rejectionReasonControl.setValidators([Validators.required]);
          rejectionReasonControl.updateValueAndValidity();

          // Scroll for visibility
          setTimeout(() => this.scrollToRejectionReason(), 100);
        }
        return; // stop here, wait for second click
      }

      // Second click → validate rejection reason
      if (rejectionReasonControl) {
        if (!rejectionReasonControl.value || rejectionReasonControl.value.trim() === '') {
          rejectionReasonControl.markAsTouched();
          return;
        }
      }

      // ✅ Call API now
      this.verifyRejectDocument(doc, status);
    }
  }


  rejectDocument(sts:any,doc: any) {
    Swal.fire({
      title: 'Reject Document',
      text: 'Please provide a reason for rejecting this document:',
      input: 'textarea',
      inputPlaceholder: 'Enter reason here...',
      inputAttributes: {
        'aria-label': 'Enter reason here',
        'rows': '2'
      },
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Reject',
      cancelButtonText: 'Cancel',
      preConfirm: (reason) => {
        if (!reason || reason.trim() === '') {
          Swal.showValidationMessage('Reason is required');
        }
        return reason;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const reason = result.value;
        this.documentForm.controls.rejectionReason.patchValue(reason);
        this.verifyRejectDocument(doc, sts);
      }
    });
  }



  toggleStatusButtons() {
    this.showStatusButtons = !this.showStatusButtons;
  }

  // Scroll to rejection reason field
  scrollToRejectionReason() {
    const rejectionReasonElement = document.getElementById('rejectionReason');
    if (rejectionReasonElement) {
      rejectionReasonElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });

      // Optional: Focus on the field for better accessibility
      setTimeout(() => {
        rejectionReasonElement.focus();
      }, 300);
    }
  }

  // Date validation methods
  static dateRangeValidator(fromFieldName: string, toFieldName: string) {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const fromField = formGroup.get(fromFieldName);
      const toField = formGroup.get(toFieldName);

      if (!fromField || !toField) {
        return null;
      }

      const fromDate = fromField.value;
      const toDate = toField.value;
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day for accurate comparison

      // Clear previous custom errors
      if (fromField.errors) {
        delete fromField.errors['futureDate'];
        if (Object.keys(fromField.errors).length === 0) {
          fromField.setErrors(null);
        }
      }

      if (toField.errors) {
        delete toField.errors['dateRange'];
        delete toField.errors['selectFromDateFirst'];
        if (Object.keys(toField.errors).length === 0) {
          toField.setErrors(null);
        }
      }

      // Check if from date is in the future (should only accept past and present dates)
      if (fromDate) {
        const from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);

        if (from > today) {
          const errors = fromField.errors || {};
          errors['futureDate'] = true;
          fromField.setErrors(errors);
          return { futureDate: true };
        }
      }

      // If to date is selected but from date is not
      if (toDate && !fromDate) {
        const errors = toField.errors || {};
        errors['selectFromDateFirst'] = true;
        toField.setErrors(errors);
        return { selectFromDateFirst: true };
      }

      // If both dates are selected, check if to date is before from date
      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);

        if (to < from) {
          const errors = toField.errors || {};
          errors['dateRange'] = true;
          toField.setErrors(errors);
          return { dateRange: true };
        }
      }

      return null;
    };
  }

  // Initialize reactive form based on document configuration
  initializeForm(obj?: any) {
    const formControls: { [key: string]: any } = {};
    const dateFields: { fromField?: string, toField?: string } = {};

    if (this.currentDocumentConfig?.fields) {
      this.currentDocumentConfig.fields.forEach(field => {
        const validators = [];

        // Add required validator if field is required
        if (field.required) {
          validators.push(Validators.required);
        }

        // Track date fields for range validation
        if (field.type === 'date') {
          if (field.id.includes('valid') || field.id.includes('From') || field.id.includes('issue') || field.id.includes('arrival')) {
            dateFields.fromField = field.id;
          }
          if (field.id.includes('valid') || field.id.includes('Until') || field.id.includes('expir') || field.id.includes('Expir')) {
            dateFields.toField = field.id;
          }
        }

        // Initialize with null for ng-select dropdowns, empty string for others
        const initialValue = (field.type === 'select') ? null : '';
        formControls[field.id] = [initialValue, validators];
      });
    }

    // Add rejection reason field (conditional validation will be handled separately)
    formControls['rejectionReason'] = [''];

    //add file id 
    formControls['fileId'] = [''];

    //add documentkey
    formControls['documentKey']=[''];

    // Create the FormGroup
    this.documentForm = this.formBuilder.group(formControls);

    // Add date range validator if both from and to date fields exist
    if (dateFields.fromField && dateFields.toField) {
      this.documentForm.setValidators(
        CandidateDocumentsComponent.dateRangeValidator(dateFields.fromField, dateFields.toField)
      );
    }

    console.log('Form initialized with controls:', Object.keys(formControls));
    console.log('Date fields detected:', dateFields);

    if (obj) {
      const patchedObj: any = { ...obj };

      // Convert expiryDate if present
      if (patchedObj.expiryDate) {
        const d = new Date(patchedObj.expiryDate);
        patchedObj.expiryDate = d.toISOString().split('T')[0]; // yyyy-MM-dd
      }

      // Same for validFromDate if needed
      if (patchedObj.validFromDate) {
        const d = new Date(patchedObj.validFromDate);
        patchedObj.validFromDate = d.toISOString().split('T')[0];
      }

      if (patchedObj.completedOn) {
        const d = new Date(patchedObj.completedOn);
        patchedObj.completedOn = d.toISOString().split('T')[0];
      }

      if(patchedObj.documentKey){
        patchedObj.fileId = patchedObj.documentKey;
      }

      this.documentForm.patchValue(patchedObj);
    }

  }

  // Helper method to check if a field has errors
  hasFieldError(fieldId: string): boolean {
    const field = this.documentForm.get(fieldId);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  // Helper method to get field error message
  getFieldError(fieldId: string): string {
    const field = this.documentForm.get(fieldId);
    if (field && field.errors) {
      const fieldConfig = this.currentDocumentConfig?.fields.find(f => f.id === fieldId);
      if (field.errors['required']) {
        if (fieldId === 'rejectionReason') {
          return 'Rejection reason is required when document is rejected';
        }
        if(fieldId === 'originalFileName'){
          return 'Please upload a file'
        }
        if(fieldId === 'comments'){
          return 'Comments required'
        }
        return `${fieldConfig?.label || fieldId} is required`;
      }
      if (field.errors['futureDate']) {
        return `${fieldConfig?.label || fieldId } should not be in the future. Please select a past or present date.`;
      }
      const fromKeywords = ['From', 'arrival', 'issue'];
      const fromField = this.currentDocumentConfig.fields.find(f => fromKeywords.some(key => f.id.includes(key)));
      if (field.errors['selectFromDateFirst']) {
        return `Please select ${fromField?.label ?? 'From date'} to proceed ${fieldConfig?.label || fieldId }.`;
      }
      if (field.errors['dateRange']) {
        return `${fieldConfig?.label || fieldId } should be after the ${fromField?.label ?? 'From date'}`;
      }
    }
    return '';
  }

  // Helper method to check if a field is a "to date" field
  isToDateField(fieldId: string): boolean {
    const toDateFields = ['validUntil', 'expirationDate', 'validTo', 'expiry', 'endDate'];
    return toDateFields.some(toField => fieldId.includes(toField)) ||
      fieldId.toLowerCase().includes('until') ||
      fieldId.toLowerCase().includes('expir');
  }

  // Helper method to check if a field is a "from date" field
  isFromDateField(fieldId: string): boolean {
    return fieldId.includes('validFrom') ||
      fieldId.includes('issueDate') ||
      fieldId.includes('arrivalDate') ||
      fieldId.includes('startDate') ||
      fieldId.toLowerCase().includes('from') ||
      fieldId.toLowerCase().includes('issue') ||
      fieldId.toLowerCase().includes('arrival') ||
      fieldId === 'completedOn'; // For background check completion dates
  }

  // Helper method to get the corresponding "from date" value
  getFromDateValue(toFieldId: string): string {
    if (!this.currentDocumentConfig?.fields) return '';

    // Find the corresponding from date field
    const fromDateField = this.currentDocumentConfig.fields.find(field =>
      field.type === 'date' &&
      (field.id.includes('validFrom') ||
        field.id.includes('issueDate') ||
        field.id.includes('arrivalDate') ||
        field.id.includes('startDate') ||
        field.id.toLowerCase().includes('from') ||
        field.id.toLowerCase().includes('issue') ||
        field.id.toLowerCase().includes('arrival'))
    );

    if (fromDateField) {
      const fromDateControl = this.documentForm.get(fromDateField.id);
      return fromDateControl ? fromDateControl.value : '';
    }

    return '';
  }

  // Helper method to get current document data from form
  getCurrentDocumentFromForm(): any {
    return {
      ...this.documentForm.getRawValue(),
      jobId: this.jobId,
      candidateId: this.candidateId,
      documentType: this.getConversationKey(this.DocumentName),
      fileId: this.documentForm.get('fileId')?.value || null
    };
  }

  // Reset form and related data
  resetForm() {
    this.documentForm.reset();
    this.selectedFiles = [];
    this.formData = {};
    this.formErrors = {};
    this.fileDragdrop = null;
    this.resumeupload = null;
    this.documentStatus = 'pending';
    this.showStatusButtons = false;
    this.showRejectionReason = false;
  }

  async submitModal() {
    if (this.modalType == 'edit') {
      this.editDocument();
      return;
    }
    // Check if file is uploaded for documents that require upload
    if (this.currentDocumentConfig?.uploadAvailable &&
      this.selectedFiles.length === 0 && this.fileDragdrop === null) {
      Swal.fire('', 'Please select a file to upload.', 'info');
      return;
    }

    // Validate reactive form
    if (this.documentForm.invalid) {
      this.documentForm.markAllAsTouched();
      // Swal.fire('', 'Please fill in all required fields.', 'info');
      return;
    }

    let formData = new FormData();
    formData.append('file', this.fileDragdrop?.file || this.selectedFiles[0]);
    // Clone form values and add extra fields - use getRawValue() to include disabled fields
    let obj: any = {
      ...this.documentForm.getRawValue(),
      jobId: this.jobId,
      candidateId: this.candidateId,
      conversationKey: this.getConversationKey(this.DocumentName)
    };
    formData.append('documentConfig', new Blob([JSON.stringify(obj)], { type: "application/json" }));

    console.log('formdata:::: ', formData);


    this.util.startLoader();
    this.api.create('jobs/uploadCandidateDocument', formData)
      .pipe(
        finalize(() => this.util.stopLoader()) // always stop loader
      ).subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.code == '00000') {
            Swal.fire({
              title: 'Success',
              text: 'Document uploaded successfully.',
              icon: 'success',
              timer: 4000,
              showConfirmButton : false
            });
            setTimeout(() => {
              this.dataChanged.emit();
              this.resetForm();
              this.closeModal();
            }, 4000);
            
          } else {
            Swal.fire('', res.message, 'error');
          }
        },
        error: (err: any) => {
          console.log(err);
          Swal.fire('Something went wrong', '', 'error');
        }
      }
      );
  }

  private readonly docMap: Record<string, string> = {
    'Resume': 'RESUME',
    'Drivers License': 'DRIVERS_LICENSE',
    'Employment Authorization Document': 'EMPLOYMENT_AUTHORIZATION',
    'Passport': 'PASSPORT',
    'Visa': 'VISA',
    'I-94': 'I94',
    'Background Check Certification': 'BACKGROUND_CHECK_CERTIFICATION',
    'Background Verification': 'BACKGROUND_CHECK',
    'Drug Screening': 'DRUG_SCREEN'
  };

  getConversationKey(docName: string): string {
    return this.docMap[docName] || '';
  }

  getDocName(conversationKey: string): string {
    // reverse lookup
    const entry = Object.entries(this.docMap).find(([_, key]) => key === conversationKey);
    return entry ? entry[0] : '';
  }


  verifyRejectDocument(doc: any, status: any) {
    // If status is rejected, ensure rejection reason is provided
    if (status === 'rejected') {
      const rejectionReasonControl = this.documentForm?.get('rejectionReason');
      if (!rejectionReasonControl || !rejectionReasonControl.value || rejectionReasonControl.value.trim() === '') {
        Swal.fire('', 'Please provide a reason for rejecting this document.', 'info');
        return;
      }
    }

    let payload = {
      jobId: this.jobId,
      candidateId: this.candidateId,
      conversationKey: this.getConversationKey(this.DocumentName),
      status: status.toUpperCase(),
      rejectComments: '',
      fileId: this.documentForm.get('fileId')?.value || ''
    }

    if (status == 'rejected') {
      payload.rejectComments = this.documentForm?.get('rejectionReason')?.value || '';
    }

    console.log('payload to change status to verify/reject: ', payload);

    this.util.startLoader();
    this.api.create('jobs/updateDocumentStatus', payload)
      .pipe(finalize(() => { this.util.stopLoader() }))
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.code == '00000') {
            Swal.fire({
              title: 'Success',
              text: 'Document status updated successfully.',
              icon: 'success',
              timer: 4000,
              showConfirmButton: false
            });
             setTimeout(() => {
              this.dataChanged.emit();              
              this.documentStatus = 'pending';
              this.showRejectionReason = false;
              this.resetForm();
              this.closeModal();
            }, 4000);
          } else {
            Swal.fire('', res?.message, 'error');
          }
        },
        error: (err: any) => {
          Swal.fire('Something went wrong', '', 'error');
        }
      });
  }

  editDocument() {
    let formData = new FormData();
    formData.append('file', this.fileDragdrop?.file || this.selectedFiles[0]);
    // Clone form values and add extra fields - use getRawValue() to include disabled fields
    let obj: any = {
      ...this.documentForm.getRawValue(),
      jobId: this.jobId,
      candidateId: this.candidateId,
      documentType: this.getConversationKey(this.DocumentName)
    };

    
    if(obj.documentType.includes(['BACKGROUND_CHECK','DRUG_SCREEN'])){
      obj.fileId = obj.documentKey;
    }
    formData.append('documentConfig', new Blob([JSON.stringify(obj)], { type: "application/json" }));

    console.log('formdata:::: ', formData);

    this.util.startLoader();
    this.api.updatePut('jobs/updateCandidateDocument', formData)
      .pipe(finalize(() => { this.util.stopLoader() }))
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.code == '00000') {
            Swal.fire({
              title: 'Success',
              text: 'Document edited successfully.',
              icon: 'success',
              showConfirmButton: false,
              timer: 4000
            });
             setTimeout(() => {
              this.dataChanged.emit();
              this.resetForm();
              this.closeModal();
            }, 4000);
          } else {
            Swal.fire('', res?.message, 'error');
          }
        },
        error: (err: any) => {
          Swal.fire('Something went wrong', '', 'error');
        }
      });
  }

  deleteDocument(doc: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this document!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#8B5CF6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        let payload = {
          jobId: this.jobId,
          candidateId: this.candidateId,
          documentType: doc?.documenttype,
          fileId: doc?.fileId,
          documentKey: doc?.documentKey
        };

        console.log('payload to delete: ', payload);

        this.util.startLoader();
        this.api.updatePut('jobs/deleteDocumentRecord', payload)
          .pipe(finalize(() => { this.util.stopLoader() }))
          .subscribe({
            next: (res: any) => {
              if (res.code == '00000') {
                Swal.fire({
                  title: 'Deleted',
                  text: 'Document deleted successfully.',
                  icon: 'success',
                  timer: 4000,
                  showConfirmButton : false
                });
                 setTimeout(() => {
                    this.dataChanged.emit();
                  }, 4000);
              } else {
                Swal.fire('', res?.message, 'error');
              }
            },
            error: (err: any) => {
              Swal.fire('Something went wrong', '', 'error');
            }
          });
      }
    });
  }


  getStatusClass(status: string): string {
    switch (status) {
      case 'VERIFIED':
        return 'badge badge-verified';
      case 'EXPIRED':
        return 'badge badge-expired';
      case 'PENDING_VERIFICATION':
        return 'badge badge-pending';
      case 'REJECTED':
        return 'badge badge-expired';
      case 'SUBMITTED':
        return 'badge badge-expired';
      default:
        return 'badge badge-default';
    }
  }


  getStatusText(sts: any): string {
    switch (sts) {
      case 'PENDING_VERIFICATION':
        return 'Pending verification';
      case 'VERIFIED':
        return 'Verified';
      case 'REJECTED':
        return 'Rejected';
      case 'EXPIRED':
        return 'Expired';
      case 'SUBMITTED':
        return 'Submitted';
      default:
        return sts;
    }
  }

  // Get the most recent or highest priority status from document list
  getDocumentHeaderStatus(documents: any[]): string {
    if (!documents || documents.length === 0) {
      return '';
    }

    // Priority order: VERIFIED > EXPIRED > REJECTED > PENDING_VERIFICATION
    // const hasVerified = documents.some(doc => doc.status === 'VERIFIED');
    // const hasExpired = documents.some(doc => doc.status === 'EXPIRED');
    // const hasRejected = documents.some(doc => doc.status === 'REJECTED');
    // const hasPending = documents.some(doc => doc.status === 'PENDING_VERIFICATION');

    // if (hasVerified) {
    //   return 'status-verified';
    // } else if (hasExpired) {
    //   return 'status-expired';
    // } else if (hasRejected) {
    //   return 'status-rejected';
    // } else if (hasPending) {
    //   return 'status-pending';
    // }

    let currentStatus = '';
    for (const doc of documents) {
      currentStatus = doc.status;
    }

    switch(currentStatus){
      case 'VERIFIED':
        return 'status-verified';
      case 'EXPIRED':
        return 'status-expired';
      case 'REJECTED':
        return 'status-rejected';
      case 'PENDING_VERIFICATION':
        return 'status-pending';
      default:
        return '';      
    }    

    return '';
  }

  

  // Get status text for document header
  getDocumentHeaderStatusText(documents: any[]): string {
    if (!documents || documents.length === 0) {
      return '';
    }

    // const hasVerified = documents.some(doc => doc.status === 'VERIFIED');
    // const hasExpired = documents.some(doc => doc.status === 'EXPIRED');
    // const hasRejected = documents.some(doc => doc.status === 'REJECTED');
    // const hasPending = documents.some(doc => doc.status === 'PENDING_VERIFICATION');

    // if (hasVerified) {
    //   return 'Verified';
    // } else if (hasExpired) {
    //   return 'Expired';
    // } else if (hasRejected) {
    //   return 'Rejected';
    // } else if (hasPending) {
    //   return 'Pending Verification';
    // }

    let currentStatus = '';
    for (const doc of documents) {
      currentStatus = doc.status;
    }

    switch(currentStatus){
      case 'VERIFIED':
        return 'Verified';
      case 'EXPIRED':
        return 'Expired';
      case 'REJECTED':
        return 'Rejected';
      case 'PENDING_VERIFICATION':
        return 'Pending Verification';
      default:
        return '';      
    }
  }

  async openDocument(doc: any): Promise<void> {
    console.table('document all details : ',doc);
    if (!doc?.fileId) {
      console.error("File URL not available for this document");
      Swal.fire('', 'File not available for this document', 'error');
      return;
    }

    try {
      this.util.startLoader();
      const url = AppSettings.photoUrl + doc.fileId;

      // Fetch the document as a blob
      const blob = await this.documentViewerService.fetchDocument(url);

      // Determine file type from filename or MIME type
      const fileType = this.documentViewerService.getFileType(
        doc.originalFileName || doc.fileName || 'document',
        blob.type
      );

      // Open in document viewer
      this.documentViewerService.openDocument({
        fileName: doc.originalFileName || doc.fileName || 'document',
        fileBlob: blob,
        fileType: fileType,
        allowDownload: true,
        allowPrint: true
      });

      this.util.stopLoader();
    } catch (error) {
      this.util.stopLoader();
      console.error('Error opening document:', error);
      Swal.fire('', 'Failed to load document. Please try again.', 'error');
    }
  }

  downloadDocument(doc: any): void {
    if (doc?.fileId) {
      // Files are served from the API origin, so an anchor's `download`
      // attribute is ignored (it only applies same-origin) and the browser
      // navigated the current tab to the file. Open it in its own tab.
      window.open(AppSettings.photoUrl + doc.fileId, '_blank', 'noopener');
    } else {
      console.error("File URL not available for this document");
    }
  }

  isPendingAvailable(item:any): boolean{
    return item.some(d => d.status === 'PENDING_VERIFICATION');
  }

  // Method to refresh document configuration after EAD list changes
  refreshDocumentConfig() {
    if (this.DocumentName && this.DocumentName === 'Employment Authorization Document') {
      this.currentDocumentConfig = this.getDocumentConfig(this.DocumentName);
      console.log('Document config refreshed with EAD list:', this.eadList);
      console.log('Updated currentDocumentConfig:', this.currentDocumentConfig);
      // Trigger change detection to update the view
      this.cdr.detectChanges();
    }
  }

  // Handler for country of citizenship change
  onCountryOfCitizenshipChange(event: any) {
    const countryCode = event?.target?.value;
    // const countryCode = event?.countryCode;
    console.log('Country of citizenship changed to:', countryCode);
    if (countryCode) {
      // Reset the employDocumentType field when country changes
      const employDocTypeControl = this.documentForm.get('employDocumentType');
      if (employDocTypeControl) {
        employDocTypeControl.setValue(null);
      }
      this.getEADType(countryCode);
    } else {
      // If country is cleared, clear EAD list and document type
      this.eadList = [];
      const employDocTypeControl = this.documentForm.get('employDocumentType');
      if (employDocTypeControl) {
        employDocTypeControl.setValue(null);
      }
      this.refreshDocumentConfig();
    }
  }

  // Helper method to check if EAD dropdown should be disabled
  isEADDropdownDisabled(): boolean {
    const countryControl = this.documentForm.get('countryOfCitizenship');
    return !countryControl || !countryControl.value || this.eadList.length === 0;
  }
}

